import React from "react";
import PropTypes from "prop-types";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  FormGroup,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";

const CampaignFormatModal = props => {
  const {
    isOpen,
    toggle,
    data,
    addCampaignFormat,
    updateCampaignFormatProfile,
    editData,
  } = props;

  const handleValidOrderSubmit = (e, errors, params) => {
    if (errors?.length === 0) {
      let format = {
        ...params,
      };

      if (editData !== null) {
        updateCampaignFormatProfile(editData.id, format, data);
        toggle();
      } else {
        addCampaignFormat(format, data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} campaign format
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
        <ModalBody>
          <Row form>
            <Col className="col-12">
              <FormGroup className="mb-3">
                <Label>Format name</Label>
                <AvField
                  name="name"
                  type="text"
                  errorMessage="This value is required."
                  value={editData?.name || ""}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter name",
                    },
                  }}
                  placeholder="Format name..."
                />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label>Description</Label>
                <AvField
                  name="description"
                  type="text"
                  errorMessage="This value is required."
                  value={editData?.description || ""}
                  placeholder="Description..."
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "Please, enter description",
                    },
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {props.permissions?.["change_campaignformatmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

CampaignFormatModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  addCampaignFormat: PropTypes.func,
  editData: PropTypes.any,
  updateCampaignFormatProfile: PropTypes.func,
  permissions: PropTypes.any,
};

export default CampaignFormatModal;
